export default __webpack_public_path__ + "04523f35d105a906a28278a64222ab88.png";